import { BaseModel, fillOwnProperties, registerModel } from '~/shared/model'
import { isUnknownObject } from '~/shared/utils/guards'

export default class UnifiedProfileEducation extends BaseModel {
  static override constructorName = 'UnifiedProfileEducationModel'

  'university_id': number | null = null
  university: string = ''
  'other_university': string | null = null
  'course_id': number | null = null
  course: string = ''
  'studying_start_year': number | null = null
  'studying_end_year': number | null = null
  faculty: string | null = null
  department: string | null = null
  'specialization_id': number | null = null
  specialization: string = ''
  'education_id': number | null = null
  education: string = ''
  'educationlevel_id': number | null = null
  educationlevel: string = ''
  'studyingform_id': number | null = null
  studyingform: string = ''
  'financingtype_id': number | null = null
  financingtype: string = ''
  'is_studying_in_target_direction': boolean = false
  'is_spo': boolean = false

  constructor(data?: unknown) {
    super(data)
    if (isUnknownObject(data)) {
      fillOwnProperties(this, data)
    }
  }
}

registerModel(UnifiedProfileEducation)
